import React from "react"

import StoryblokImage from "../../internal/storyblokImage/StoryblokImage"
import StoryblokLink from "../../internal/storyblokLink/StoryblokLink"
import * as styles from "./iconButton.module.scss"

const iconButton = ({ buttonProps, withClass }) => {
      if(buttonProps && buttonProps.cta_link && buttonProps.cta_link.fieldtype) {
        if(buttonProps.icon && buttonProps.icon.filename !== ""){
            return (
                <div className={styles.iconButton}>
                <StoryblokLink  withClass={`btn start-link ${buttonProps.cta_color ? buttonProps.cta_color : "black"} ${withClass ? withClass : ""}`} SBLinkData={buttonProps.cta_link} newWindow={buttonProps.target}>
                    {buttonProps.text}<StoryblokImage sbImageData={buttonProps.icon}/>
                </StoryblokLink>
                </div>
            )
        }
        return (
          <StoryblokLink text={buttonProps.text} withClass={`btn start-link ${buttonProps.cta_color ? buttonProps.cta_color : "black"} ${withClass ? withClass : ""}`} SBLinkData={buttonProps.cta_link} newWindow={buttonProps.target}/>
        )
      }
}
 
export default iconButton;